import { useApmTraceStore } from "@/shared/store/apm-trace-store.ts";
import { init as initApm } from "@elastic/apm-rum";
import { Router } from "vue-router";

declare global {
    interface Window {
        __APP_VERSION__?: string;
    }
}

let apmTraceId: string | null = null;

export function getApmTraceId(): string {
    if (apmTraceId) return apmTraceId;

    // Initialize on first call - Pinia will be available at this point
    const apmStore = useApmTraceStore();
    apmTraceId = apmStore.traceId !== "" ? apmStore.traceId : Math.random().toString(16).slice(2);
    apmStore.setTraceId(apmTraceId);

    return apmTraceId;
}

const FILTERED_ERROR_MESSAGES = ["ResizeObserver loop completed with undelivered notifications."];

export const getApmOptions = (router: Router) => {
    const apm = initApm({
        serviceName: "info-twin",
        serverUrl: (<HTMLInputElement>document.getElementById("apm_server"))?.value ?? "",
        pageLoadTraceId: getApmTraceId(),
        serviceVersion: window.__APP_VERSION__,
    });

    apm.addFilter((payload) => {
        if (payload.errors) {
            payload.errors = payload.errors.filter((error) => {
                return !FILTERED_ERROR_MESSAGES.includes(error.exception?.message ?? "");
            });
            if (payload.errors.length === 0) return false;
        }
        return payload;
    });

    return {
        router,
        apmBase: apm,
    };
};
